import { toReportNumber } from './reportNumbers';
const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
const formatDateTime = (isoString) => {
  if (!isoString) return "-";
  const s = String(isoString).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
  if (!m) return s;

  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  const hour24 = Number(m[4]);
  const minute = Number(m[5]);

  if (
    !Number.isFinite(year) ||
    !Number.isFinite(month) ||
    !Number.isFinite(day)
  )
    return s;
  if (!Number.isFinite(hour24) || !Number.isFinite(minute)) return s;
  if (month < 1 || month > 12) return s;

  const ampm = hour24 >= 12 ? "PM" : "AM";
  const hour12 = hour24 % 12 || 12;
  return `${MONTHS[month - 1]} ${day}, ${year}, ${String(hour12).padStart(2, "0")}:${String(minute).padStart(2, "0")} ${ampm}`;
};
const formatMinutes = (minutes) => {
  if (!Number.isFinite(minutes)) return "-";
  const totalMinutes = Math.round(minutes);
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
};

// Match the Orders table search when exporting a newly fetched date range.
export const matchesOrderSearch = (order, search = '') => {
  const term = search.trim().toLowerCase();
  return ['order_id', 'member_name', 'server_name', 'table_name']
    .some(field => String(order[field] ?? '').toLowerCase().includes(term));
};

// Share ticket formatting and lifecycle values between the table and independent exports.
export const buildOrdersReportRows = ({ ordersList = [], ordersItemsCount = [], ordersBumpMinutes = [] }) => {
  const itemCountsMap = Object.fromEntries(ordersItemsCount.map(row => [row.order_id, row]));
  const ticketMinutesMap = Object.fromEntries(ordersBumpMinutes.map(row => [row.order_id, toReportNumber(row.ticket_minutes)]));
  const bumpMinutesMap = Object.fromEntries(ordersBumpMinutes.map(row => [row.order_id, toReportNumber(row.bump_minutes)]));
  const bumpStatusMap = Object.fromEntries(ordersBumpMinutes.map(row => [row.order_id, row.performance_status || null]));
  return ordersList.map((order) => {
    // Show wall-clock receipt-to-completion time; performance separately uses active kitchen time.
    const ticketMinutes = ticketMinutesMap[order.order_id] ?? null;

    return {
      ...order,

      received_atFormatted: formatDateTime(order.received_at),
      bumped_atFormatted: formatDateTime(order.bumped_at),
      ticket_time: ticketMinutes,
      ticket_timeFormatted: formatMinutes(ticketMinutes),

      items: itemCountsMap[order.order_id]?.item_count ?? 0,

      bump_minutes: bumpMinutesMap[order.order_id] ?? null,

      bumpStatus: bumpStatusMap[order.order_id] ?? null,
    };
  });
};
